(function(){
  'use strict';
  function init(){
    var body=document.querySelector('[data-article-body]');
    if(!body||body.dataset.lnVisualReady==='true')return;
    body.dataset.lnVisualReady='true';
    var nodes=Array.prototype.slice.call(body.childNodes);
    var sections=[];
    var intro=[];
    var current=null;
    nodes.forEach(function(node){
      if(node.nodeType===1&&node.tagName==='H2'){
        current={heading:node,content:[]};
        sections.push(current);
      }else if(current){current.content.push(node);}else{intro.push(node);}
    });
    if(sections.length<3)return;
    body.innerHTML='';
    if(intro.some(function(node){return String(node.textContent||'').trim()||node.nodeType===1;})){
      var introWrap=document.createElement('div');
      introWrap.className='ln-av__intro';
      intro.forEach(function(node){introWrap.appendChild(node);});
      body.appendChild(introWrap);
    }
    var lead=sections.shift();
    var leadSection=document.createElement('section');
    leadSection.className='ln-av__lead';
    leadSection.appendChild(lead.heading);
    var leadPanel=document.createElement('div');
    leadPanel.className='ln-av__panel rte';
    lead.content.forEach(function(node){leadPanel.appendChild(node);});
    leadSection.appendChild(leadPanel);
    body.appendChild(leadSection);
    var stack=document.createElement('div');
    stack.className='ln-av__stack';
    sections.forEach(function(section,index){
      var details=document.createElement('details');
      details.className='ln-av__item';
      if(section.heading.id)details.id=section.heading.id;
      var summary=document.createElement('summary');
      var icon=document.createElement('span');
      icon.className='ln-av__icon';
      icon.setAttribute('aria-hidden','true');
      icon.textContent=String(index+2).padStart(2,'0');
      var title=document.createElement('span');
      title.textContent=section.heading.textContent;
      var plus=document.createElement('span');
      plus.className='ln-av__plus';
      plus.setAttribute('aria-hidden','true');
      plus.textContent='+';
      summary.appendChild(icon);summary.appendChild(title);summary.appendChild(plus);
      var panel=document.createElement('div');
      panel.className='ln-av__panel rte';
      section.content.forEach(function(node){panel.appendChild(node);});
      details.appendChild(summary);details.appendChild(panel);stack.appendChild(details);
      details.addEventListener('toggle',function(){
        if(!details.open)return;
        stack.querySelectorAll('details[open]').forEach(function(other){if(other!==details)other.removeAttribute('open');});
        document.dispatchEvent(new CustomEvent('ln:event',{detail:{event:'article_section_open',section:title.textContent.slice(0,100)}}));
      });
    });
    body.appendChild(stack);
    function openHash(){
      if(!window.location.hash)return;
      var target=document.querySelector(window.location.hash);
      if(target&&target.matches('.ln-av__item'))target.open=true;
    }
    openHash();
    window.addEventListener('hashchange',openHash);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
